$(function() {
    var stylinglist_length = $(".styling_block .styling_box").length;
    Number(stylinglist_length);
    var stylinglist_width = 100 / stylinglist_length;
    $('.styling_block .styling_box').css('width',stylinglist_width + "%");

    var newslist_length = $(".slider_news_3 .news_box").length;
    Number(newslist_length);
    var newslist_length_minus = newslist_length - 1;
    var newslist_gap = newslist_length_minus * 8;
    var newslist_width = 100 / newslist_length;
    var gap = newslist_gap / newslist_length;
    $('.slider_news_3 .news_box').css("width", "calc(" + newslist_width + "% - " + gap + "px)" );

    var bloglist_length = $(".slider_blog .news_box").length;
    Number(bloglist_length);
    var bloglist_length_minus = bloglist_length - 1;
    var bloglist_gap = bloglist_length_minus * 8;
    var bloglist_width = 100 / bloglist_length;
    var gap = bloglist_gap / bloglist_length;
    $('.slider_blog .news_box').css("width", "calc(" + bloglist_width + "% - " + gap + "px)" );

    $('.slider_top').slick({
      autoplay:{
        delay: 3000
      },
      arrows:false,
      dots: true,
      autoplay: true,
      adaptiveHeight: true,
      fade: true,
      cssEase: 'ease',
      speed: 3000,
      pauseOnHover: false,
      pauseOnFocus: false
    });
    $('.slider_top').on('touchstart', function () {
      $(this).slick('slickPlay');
    });
    var A_JP_carousel_1 = new Swiper('.A_JP_carousel_1', {
      a11y: false,
      slidesPerView: 1,
      loop: false,
      fadeEffect: { crossFade: true },
      effect: "fade",
      autoplay: {
          delay: 5000,
          disableOnInteraction: false,
      },
      speed: 300,
      pagination: {
          el: '.A_JP_carousel_1 .swiper-pagination',
          clickable: true
        },
    });

    var A_DP_carousel_2 = new Swiper('.A_DP_carousel_2', {
      a11y: false,
      slidesPerView: 1,
      loop: false,
      fadeEffect: { crossFade: true },
      effect: "fade",
      autoplay: {
          delay: 5000,
          disableOnInteraction: false,
      },
      speed: 300,
      pagination: {
          el: '.A_DP_carousel_2 .swiper-pagination',
          clickable: true
        },
    });

    var A_GV_banner_full = new Swiper('.A_GV_banner_full', {
      a11y: false,
      slidesPerView: 1,
      loop: false,
      fadeEffect: { crossFade: true },
      effect: "fade",
      autoplay: {
          delay: 5000,
          disableOnInteraction: false,
      },
      speed: 300,
      pagination: {
          el: '.A_GV_banner_full .swiper-pagination',
          clickable: true
        },
    });

    var A_JAMESPERSE_banner_full = new Swiper('.A_JAMESPERSE_banner_full', {
      a11y: false,
      slidesPerView: 1,
      loop: true,
      fadeEffect: { crossFade: true },
      effect: "fade",
      autoplay: {
          delay: 5000,
          disableOnInteraction: false,
      },
      speed: 300,
      navigation: {
        nextEl: '.swiper-item-next',
        prevEl: '.swiper-item-prev',
      },
      pagination: {
          el: '.A_JAMESPERSE_banner_full .swiper-pagination',
          clickable: true
      }
    });

    var A_TMLm_carousel_1 = new Swiper('.A_TMLm_carousel_1', {
      a11y: false,
      slidesPerView: 1,
      loop: false,
      fadeEffect: { crossFade: true },
      effect: "fade",
      autoplay: {
          delay: 5000,
          disableOnInteraction: false,
      },
      speed: 300,
      pagination: {
          el: '.A_TMLm_carousel_1 .swiper-pagination',
          clickable: true
        },
    });
    
    $('.slider_arrival').slick({
      autoplay:false,
      arrows:true,
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      responsive: [{
        breakpoint: 768,
          settings: {
            slidesToShow: 2.5,
            slidesToScroll: 2,
            arrows:false,
        }
      }
      ]
    });

    $(function(){
      function sliderSetting(){
          var width = $(window).width();
          if(width > 768){
              $('.slider_arrival-tmlw').not('.slick-initialized').slick({
                autoplay:false,
                arrows:true,
                slidesToShow: 5,
                speed: 300,
                infinite: false,
                responsive: [{
                    breakpoint: 768,
                      settings: {
                        slidesToShow: 2.5,
                        slidesToScroll: 1,
                        arrows:false,
                    }
                  }
                ]
              });
          } else {
              $('.slider_arrival-tmlw .slide.slick-initialized').slick('unslick');
          }
      }
      sliderSetting();
      $(window).resize(sliderSetting());
    });

    $('.slider_preorder').slick({
      autoplay:false,
      arrows:true,
      slidesToShow: 4,
      infinite: false,
      responsive: [{
        breakpoint: 768,
          settings: {
            slidesToShow: 2.5,
            slidesToScroll: 1,
            arrows:false,
        }
      }
      ]
    });

    $(function(){
      function sliderSetting(){
          var width = $(window).width();
          if(width > 768){
              $('.slider_preorder-tmlw').not('.slick-initialized').slick({
                autoplay:false,
                arrows:true,
                slidesToShow: 5,
                infinite: false,
                speed: 300,
                responsive: [{
                    breakpoint: 768,
                      settings: {
                        slidesToShow: 2.5,
                        slidesToScroll: 1,
                        arrows:false,
                    }
                  }
                ]
              });
          } else {
              $('.slider_preorder-tmlw .slide.slick-initialized').slick('unslick');
          }
      }
      sliderSetting();
      $(window).resize(sliderSetting());
    });

    $('.slider_reccomend').slick({
      autoplay:false,
      arrows:true,
      slidesToShow: 4,
      autoplay: false,
      responsive: [{
        breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows:false,
        }
      }
      ]
    });
    $('.slider_topics_3').slick({
      autoplay:false,
      arrows:true,
      dots:true,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 768,
          settings: {
              autoplay: false,
              arrows:true,
              infinite: true,
              dots:true,
              slidesToShow: 1,
              slidesToScroll: 1,
        }
      }
      ]
    });
    $('.ranking_block_2').slick({
      autoplay:false,
      arrows:true,
      slidesToShow: 5,
      infinite: true,
      responsive: [{
        breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows:false,
        }
      }
      ]
    });
      $('.slider_label').slick({
      autoplay:false,
      arrows:true,
      slidesToShow: 3,
      dots: true,
      autoplay: false,
      responsive: [{
        breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            centerPadding: '0%',
        }
      }
      ]
    });
    $('.slider_topics_2').slick({
      autoplay:false,
      arrows:true,
      slidesToShow: 4.4,
      dots: true,
      autoplay: false,
      centerMode: true,
      adaptiveHeight: true,
      responsive: [{
        breakpoint: 768,
          settings: {
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            centerPadding: '0%',
          },
        },
        {
        breakpoint: 1240,
          settings: {
            centerPadding: '0%',
          },
        },
        {
        breakpoint: 1400,
          settings: {
            centerPadding: '4%',
          },
        },
        {
        breakpoint: 1500,
          settings: {
            centerPadding: '6%',
          },
        },
        {
        breakpoint: 1600,
          settings: {
            centerPadding: '10%',
          },
        },
        {
        breakpoint: 1700,
          settings: {
            centerPadding: '11%',
          },
        },
        {
        breakpoint: 1800,
          settings: {
            centerPadding: '12%',
          },
        },
      ],
    });
  $('.slider_news_2').slick({
      autoplay:false,
      arrows:true,
      slidesToShow: 2,
      dots: true,
      adaptiveHeight: true,
      responsive: [{
        breakpoint: 768,
          settings: {
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            centerPadding: '0%',
        }
      }
      ]
    });
  });
  
  $(function(){
    function sliderSetting(){
        var width = $(window).width();
        if(width <= 769){
            $('.styling_block').not('.slick-initialized, .styling-galerievie').slick({
                autoplay: false,
                centerMode: false,
                arrows:false,
                infinite: false,
                dots:false,
                speed: 500,
                slidesToShow: 2.5,
                slidesToScroll: 2,
                centerPadding: '0px'
            });
        } else {
            $('.styling_block .slide.slick-initialized').slick('unslick');
        }
    }
    sliderSetting();
    $(window).resize(sliderSetting());
  });

  $(function(){
    function sliderSetting(){
        var width = $(window).width();
        if(width > 768){
            $('.styling_block-tmlw').not('.slick-initialized').slick({
              autoplay:false,
              arrows:true,
              slidesToShow: 5,
              infinite: false,
              speed: 300,
              responsive: [{
                  breakpoint: 768,
                    settings: {
                      slidesToShow: 2.5,
                      slidesToScroll: 1,
                      arrows:false,
                  }
                }
              ]
            });
        } else {
            $('.styling_block-tmlw .slide.slick-initialized').slick('unslick');
        }
    }
    sliderSetting();
    $(window).resize(sliderSetting());
  });
  
  $(function(){
    function sliderSetting(){
        var width = $(window).width();
        if(width <= 769){
            $('.slider_news_3').not('.slick-initialized').slick({
                autoplay: false,
                centerMode: false,
                arrows:false,
                infinite: true,
                dots:false,
                slidesToShow: 2,
                slidesToScroll: 1,
                centerPadding: '0px',
            });
        } else {
            $('.slider_news_3 .slide.slick-initialized').slick('unslick');
        }
    }
    sliderSetting();
    $(window).resize(sliderSetting());
  });

  $(function(){
    function sliderSetting(){
        var width = $(window).width();
        if(width > 768){
            $('.slider_news_3-tmlw').not('.slick-initialized').slick({
              autoplay:false,
              arrows:true,
              slidesToShow: 5,
              infinite: false,
              speed: 300,
              responsive: [{
                  breakpoint: 768,
                    settings: {
                      slidesToShow: 2.5,
                      slidesToScroll: 1,
                      arrows:false,
                  }
                }
              ]
            });
        } else {
            $('.slider_news_3-tmlw .slide.slick-initialized').slick('unslick');
        }
    }
    sliderSetting();
    $(window).resize(sliderSetting());
  });
  
  $(function(){
    function sliderSetting(){
        var width = $(window).width();
        if(width <= 769){
            $('.slider_blog').not('.slick-initialized').slick({
                autoplay: false,
                centerMode: false,
                arrows:false,
                infinite: true,
                dots:false,
                slidesToShow: 2,
                slidesToScroll: 1,
                centerPadding: '0px',
            });
        } else {
            $('.slider_blog .slide.slick-initialized').slick('unslick');
        }
    }
    sliderSetting();
    $(window).resize(sliderSetting());
  });

  $(function(){
    function sliderSetting(){
        var width = $(window).width();
        if(width > 768){
            $('.slider_blog-tmlw').not('.slick-initialized').slick({
              autoplay:false,
              arrows:true,
              slidesToShow: 5,
              infinite: false,
              speed: 300,
              responsive: [{
                  breakpoint: 768,
                    settings: {
                      slidesToShow: 2.5,
                      slidesToScroll: 1,
                      arrows:false,
                  }
                }
              ]
            });
        } else {
            $('.slider_blog-tmlw .slide.slick-initialized').slick('unslick');
        }
    }
    sliderSetting();
    $(window).resize(sliderSetting());
});

$(function() {
  function sliderSetting() {
      var width = $(window).width();
      if (width > 768) {
          $('.slider_topic-jp').not('.slick-initialized').slick({
            autoplay:false,
            arrows:true,
            dots:true,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            speed: 300,
            responsive: [{
                breakpoint: 768,
                settings: {
                  slidesToShow: 2.2,
                  slidesToScroll: 3,
                  arrows:false,
                  dots:false,
                }
            }]
          });
      } else {
          $('.slider_topic-jp .slide.slick-initialized').slick('unslick');
      }
  }
  sliderSetting();
  $(window).resize(sliderSetting());
});

$(function() {
  function sliderSetting() {
      var width = $(window).width();
      if (width > 768) {
          $('.slider_topic-dp').not('.slick-initialized').slick({
            autoplay:false,
            arrows:true,
            dots:true,
            slidesToShow: 3,
            slidesToScroll: 1,
            speed: 300,
            responsive: [{
                breakpoint: 768,
                settings: {
                  slidesToShow: 2.2,
                  slidesToScroll: 3,
                  arrows:false,
                  dots:false,
                }
            }]
          });
      } else {
          $('.slider_topic-dp .slide.slick-initialized').slick('unslick');
      }
  }
  sliderSetting();
  $(window).resize(sliderSetting());
});


$(function() {
  new Swiper('.store-carousel', {
    a11y: false,
    slidesPerView: 1,
    loop: true,
    fadeEffect: { crossFade: true },
    effect: "fade",
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 300,
    navigation: {
      nextEl: '.store-carousel .swiper-top-next',
      prevEl: '.store-carousel .swiper-top-prev',
    },
    pagination: {
      el: '.store-carousel .swiper-pagination',
      clickable: true
    },
  });

  new Swiper('.store-carousel--not-arrow', {
    a11y: false,
    slidesPerView: 1,
    loop: true,
    fadeEffect: { crossFade: true },
    effect: "fade",
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 300,
    pagination: {
      el: '.store-carousel--not-arrow .swiper-pagination',
      clickable: true
    },
  });
});

var slickGaler = false;
function slickGalerievie () { 
  if ($(window).width() >= 768) {
    if (!slickGaler) {
      $('.slider_galerievie').slick({
        autoplay: false,
        arrows: true,
        dots: true,
        slidesToShow: 2.1,
        slidesToScroll: 1
      });
      slickGaler = true;
    }
  } else if ($(window).width() < 768) {
    if (slickGaler) {
      $('.slider_galerievie').slick('unslick');
      slickGaler = false;
    }
  }
};

var slickJames = false;
function slickJamesperse () { 
  if ($(window).width() >= 768) {
    if (!slickJames) {
      $('.slider_jamesperse').slick({
        autoplay: false,
        arrows: true,
        dots: true,
        slidesToShow: 2,
        slidesToScroll: 1
      });
      slickJames = true;
    }
  } else if ($(window).width() < 768) {
    if (slickJames) {
      $('.slider_jamesperse').slick('unslick');
      slickJames = false;
    }
  }
};

$(document).ready(function () {
  slickGalerievie();
  slickJamesperse();
});

$(window).on('resize', function () {
  slickGalerievie();
  slickJamesperse();
});